import { render, staticRenderFns } from "./delivery-method-selector.vue?vue&type=template&id=1494a76e&"
import script from "./delivery-method-selector.vue?vue&type=script&lang=js&"
export * from "./delivery-method-selector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports